import { workspaceApi } from '@/model/workspace/api.generated';

export function registerWorkspaceTags(): void {
  workspaceApi.enhanceEndpoints({
    endpoints: {
      deleteApiWorkspacesByIdInvitationsAndInvitationId: {
        invalidatesTags: ['workspaces', 'permissions'],
      },
    },
  });
}
